<template>
  <div>
    <!-- 添加/编辑-题目： -->
    <el-dialog :title="isAdd ? $t('message.addQuestion') : $t('message.editQuestion')" :close-on-click-modal="false"
      :visible.sync="dialogVisible" width="1380px" center>
      <div class="content">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
          <!-- 排序 -->
          <el-form-item :label="$t('message.sort')" prop="sort">
            <el-input v-model="ruleForm.sort" style="width: 100px;"></el-input>
            <span style="color: #c35257;">*数字越大越靠前</span>
          </el-form-item>
          <!-- 类目 -->
          <el-form-item :label="$t('message.categoryName')" prop="category_id">
            <el-select v-model="ruleForm.category_id" placeholder="请选择" style="width: 100%;">
              <el-option v-for="item in tableData" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <!-- 标题 -->
          <el-form-item :label="$t('message.title')" prop="title">
            <el-input v-model="ruleForm.title" type="textarea"></el-input>
          </el-form-item>
          <!-- icon -->
          <el-form-item label="icon">
            <el-upload :action="baseURL + '/api/common/uploadFile'" list-type="picture-card"
              :on-success="handleAvatarSuccess" :obefore-upload="beforeAvatarUpload" :show-file-list="false">
              <img v-if="ruleForm.icon" :src="ruleForm.icon" class="avatar" style="width: 100%;height: 100%;">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>

            </el-upload>
            <span style="color: #c35257;"> *icon图标只能传一张</span>
          </el-form-item>
          <!-- status -->
          <el-form-item :label="$t('message.whetherEnabled')">
            <el-switch v-model="ruleForm.show">
            </el-switch>
            <span style="color: #c35257;"> *开关默认关闭，需要人工开启</span>
          </el-form-item>

          <!-- 内筒 -->
          <el-form-item :label="$t('message.content')" prop="content">
            <quill-editor ref="myTextEditor" id="quill-editor" v-model="ruleForm.content" :options="quillOption"
              @change="onEditorChange($event)">
            </quill-editor>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <!--取 消  -->
        <el-button @click="dialogVisible = false">
          {{ $t("message.cancel") }}</el-button>
        <!-- 保存 -->
        <el-button type="primary" @click="articleStore" v-if="isAdd">
          {{ $t("message.ok") }}
        </el-button>
        <!-- 保存 -->
        <el-button type="primary" @click="articleUpdate" v-else>
          {{ $t("message.ok") }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { quillEditor } from "vue-quill-editor";
import quillConfig from "@/utlis/quill-config";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
export default {
  components: {
    quillEditor
  },
  props: {
    isAdd: { type: Boolean },
    tableData: { type: Array },
  },
  data() {
    return {
      quillOption: quillConfig,
      ruleForm: {

      },
      dialogVisible: false,
      rules: {
        category_id: [
          {
            required: true,
            message: this.$t("message.TheRequired"),
            trigger: "blur",
          },
        ],
        title: [
          {
            required: true,
            message: this.$t("message.TheRequired"),
            trigger: "blur",
          },
        ],
        content: [
          {
            required: true,
            message: this.$t("message.TheRequired"),
            trigger: "blur",
          },
        ],
        sort: [
          {
            required: true,
            message: this.$t("message.TheRequired"),
            trigger: "blur",
          },
        ]
      },
    };
  },
  methods: {

    // 新增
    articleStore() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.ruleForm.is_show = this.ruleForm.show ? 1 : 0
          this.$api.siteConfiguration.articleStore(this.ruleForm).then((res) => {
            this.$message.success(res.msg);
            this.dialogVisible = false;
            this.$parent.guideArticleList()
          });
        }
      })

    },
    // 修改
    articleUpdate() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.ruleForm.is_show = this.ruleForm.show ? 1 : 0
          this.$api.siteConfiguration.articleUpdate(this.ruleForm).then((res) => {
            this.$message.success(res.msg);
            this.dialogVisible = false;
            this.$parent.guideArticleList()
          });
        }
      })

    },
    acceptData(data) {
      this.ruleForm = data
      this.dialogVisible = true
    },
    onEditorChange(e) {
      console.log(e);
    },
    // 上传
    handleAvatarSuccess(res) {
      this.ruleForm.icon = res.data
      this.$forceUpdate()
    },
    // 上传前
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isPNG = file.type === "image/png";
      const isSVG = file.type === "image/svg+xml";
      if (!isJPG && !isPNG && !isSVG) {
        this.$message.error("上传图片只能是 JPG,PNG 格式,SVG格式!");
      }
      return isJPG || isPNG || isSVG;
    },
  },
};
</script>
<style lang='scss' scoped>
@import "../../../../../css/quillbubble.css";
@import "../../../../../css/quillcore.css";
@import "../../../../../css/quillsnow.css";

.content {
  margin: 0px 15px;


}

/deep/.ql-editor {
  min-height: 300px !important;
  max-height: 800px !important;

  p {
    font-size: 16px;
    color: #000
  }
}

/deep/ .avatar-uploader-icon {
  width: 120px;
  height: 120px;
  line-height: 120px;
}
</style>